import { dashboardConstants } from "../constants";

export const setImponibles = (data) => async (dispatch) => {
  dispatch(success(data));

  function success(data) {
    return { type: dashboardConstants.SET_IMPONIBLES, payload: data };
  }
};